import axios from "axios";
import authHeader from "../../services/AuthHeader";

const CORE_API_URL = process.env.VUE_APP_MS_CORE;


const state = () => ({
  magic: "",
  document: "",
  offline: "OFF",
  confs: [],
});

const getters = {
  getMagic(state) {
    if (state.magic == "ON") {
      return true;
    }
    return false;
  },

  getDocument(state) {
    if (state.document == "ON") {
      return true;
    }
    return false;
  },

  getConfs(state) {
    return state.confs;
  },

  isOffline(state) {
    return state.offline;
  },
};

const mutations = {
  saveMagic(state, data) {
    if (data == null) {
      state.magic = "";
    } else {
      state.magic = data.value;
    }
  },

  saveDocument(state, data) {
    if (data == null) {
      state.document = "";
    } else {
      state.document = data.value;
    }
  },

  saveOffline(state, data) {
    if (data == null) {
      state.offline = "OFF";
    } else {
      state.offline = data.value;
    }
  },

  saveConfs(state, data) {
    if (data == null) {
      state.confs = [];
    } else {
      state.confs = data.value;
    }
  },
};

const actions = {
  async loadMagicConfig({ commit }) {
    const response = await axios
      .get(`${CORE_API_URL}/config/magic`)
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("saveMagic", response.data);
    } else {
      commit("saveMagic", null);
    }
  },

  async loadDocConfig({ commit }) {
    const response = await axios
      .get(`${CORE_API_URL}/config/document`)
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("saveDocument", response.data);
    } else {
      commit("saveDocument", null);
    }
  },

  async loadSiteState({ commit }) {
    const response = await axios
      .get(`${CORE_API_URL}/config/offline`)
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("saveOffline", response.data);
    } else {
      commit("saveOffline", null);
    }
  },

  async loadAllConfig({ commit }) {
    const response = await axios
      .get(`${CORE_API_URL}/secure/configs/tag/FRONT`, {
        headers: authHeader(),
      })
      .catch((err) => {
        console.log(err);
      });
    if (response && response.data) {
      commit("saveConfs", response.data);
    } else {
      commit("saveConfs", null);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
